import { useState, useEffect } from "react";
// import { AppBar, Toolbar, Button, Typography, Stack } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next"
import LanguageSwitcher from "./utils/LanguageSwitcher"
import { fetchAndRehydrate } from "../sync/syncService";
import { store } from "../store";

import { colors, space, radius, borders, fontSize } from "../design/tokens";

import {
  Screen,
  Content,
  Card,
  TextInput,
  // Button,
  Text,
} from "../components/layout";

import { IconRefresh } from "@tabler/icons-react";



export default function Navbar () {
  const { t } = useTranslation("common")
  const navigate = useNavigate();
  const location = useLocation(); 
  const userName = useSelector((state) => state.auth.userName);

  const [refreshing, setRefreshing] = useState(false);

  const handleRefresh = async () => {
    console.log("refreshing on click: " + refreshing)
    setRefreshing(true);
    console.log("refreshing before await: " + refreshing)
    await fetchAndRehydrate(store);
    setRefreshing(false);
    console.log("refreshing after await: " + refreshing)
  };

  const tabs = [
  { key: "overview",  label: "Overview",  icon: "ti-home" }, 
  { key: "login",   label: "Login",   icon: "ti-pencil" },
  { key: "dashboard", label: "Today", icon: "ti-home" },
  { key: "logout",   label: "Logout",   icon: "ti-pencil" },
  { key: "foods", label: "Foods", icon: "ti-chart-bar" },
  { key: "meals", label: "Meals", icon: "ti-chart-bar" },
  { key: "me",    label: "Me",    icon: "ti-user" },
];

  const active = location.pathname.replace("/", "") || "home";

  return (
    <nav style={{
      display: "flex",
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      height: 64,
      color: colors.textWhite,
      background: colors.primary,
      borderTop: `1px solid ${colors.border}`,
    }}>
      <Text
      style={{padding:space.sm, fontSize:fontSize.xs}}
      >
        Version 1.9
      </Text>
      {tabs.map(tab => {
        const isActive = tab.key === active;
        return (
          <button
            key={tab.key}
            onClick={() => navigate(`/${tab.key}`)}
            // onClick={() => navigate("/")}
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 3,
              background: "none",
              border: "none",
              cursor: "pointer",
              color: isActive ? colors.textWhite : colors.textMuted,
            }}
          >
            <i className={`ti ${tab.icon}`} style={{ fontSize: 22 }} />
            <span style={{ fontSize: 11, fontWeight: isActive ? 500 : 400 }}>
              {tab.label}
            </span>
          </button>
        );
      })}
      <button
        onClick={handleRefresh}
        disabled={refreshing}
        style={{
          background: "none",
          border: "none",
          cursor: refreshing ? "wait" : "pointer",
          color: colors.textWhite,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: space.sm,
        }}
      >
        {/* <i className={`ti ti-refresh ${refreshing ? "spin" : ""}`} style={{ fontSize: 22 }} /> */}
        <IconRefresh />
      </button>
          <div style={{
            display: "flex",
            alignItems: "center",
            paddingRight: space.md,
          }}>
            <LanguageSwitcher />
          </div>
    </nav>
  );
}
